import { useEffect } from "react";

const updateTitle = () => {
  const hash = window.location.hash;
  const path = hash.replace("#", "");

  if (path.startsWith("/volkstotal")) {
    document.title = "RIO | Volks|Total";
  } else if (path.startsWith("/tms")) {
    document.title = "RIO | TMS";
  } else {
    document.title = "RIO | TMS";
  }
};

const PageTitle = () => {
  useEffect(() => {
    updateTitle();

    const handleHashChange = () => {
      updateTitle();
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return null;
};

export default PageTitle;
